import { React, useState, useEffect, useRef } from 'react'
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import { format, parse } from 'date-fns';
import { faMagnifyingGlass, faPrint, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { faFileExcel, faFilePdf, faTrashCan, faFile } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { APIConstants, FilesAPIConstants, PatientTrackerConstants, CommonAPIConstants } from '../utilities/Constants';
import { faTriangleExclamation, faStar, faCircleInfo, faArrowsRotate, faAnglesDown, faAnglesUp, faXmark, faArrowRight, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { Provider, useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import EncounterTrackerTableV2 from '../components/EncounterTrackerTableV2';
import TrackerChartV2 from '../components/TrackerChart';
import TrackerDashboardV2 from '../components/patientTrackerV2/TrackerDashboardV2';
import Draggable from 'react-draggable';

const NurseTracker = () => {


    const [startDate, setStartDate] = useState(''); // State to store start date
    const [endDate, setEndDate] = useState('');     // State to store end date
    const [loading, setLoading] = useState(false);
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);

    const [showDataModal, setShowDataModal] = useState(false);
    const [showEncModal, setShowEncModal] = useState(false);
    const [showAuditModal, setShowAuditModal] = useState(false);

    const [hasFetched, setHasFetched] = useState(false);

    const [activeRow, setActiveRow] = useState(null);
    const [unitactiveRow, setUnitActiveRow] = useState(null);
    const [counselorData, setCounselorData] = useState([]);
    const [providerData, setProviderData] = useState([]);
    const [encounterData, setEncounterData] = useState([]);
    const [CptTrackerData, setCptTrackerData] = useState([]);
    const [CptTrackerTable2, setCptTrackerTable2] = useState([]);
    const [unitTrackerTable1, setUnitTrackerTable1] = useState([]);
    const [unitTrackerTable2, setUnitTrackerTable2] = useState([]);
    const [selectedProviders, setSelectedProviders] = useState([]);
    const [locationData, setLocationData] = useState([]);
    const [selectedLocationID, setSelectedLocationID] = useState('-1');
    const [showEncounterPatient, setShowEncounterPatient] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchByProviderName, setSearchByProviderName] = useState("");
    const [searchByAllProviderName, setSearchByAllProviderName] = useState("");

    const [searchQueryTable1, setSearchQueryTable1] = useState("");
    const [searchQueryTable2, setSearchQueryTable2] = useState("");
    const [searchQueryTable3, setSearchQueryTable3] = useState("");
    const [chartType, setChartType] = useState("horizontalBar");
    const [sortConfigTable2, setSortConfigTable2] = useState({ key: null, ascending: true });
    const [sortConfigTable3, setSortConfigTable3] = useState({ key: null, ascending: true });
    const [userAuditData, setUserAuditData] = useState([]);
    const [searchByAuditDescription, setSearchByAuditDescription] = useState("");
    const [searchByEncProvider, setSearchByEncProvider] = useState("");
    const [searchByEncPatientName, setSearchByEncPatientName] = useState("");
    const [searchByAudit1Provider, setSearchByAudit1Provider] = useState("");
    const [visibleCounts, setVisibleCounts] = useState({
        totalEncounters: true,
        SignedEnc: true,
        UnsignedEnc: true,
        nonduplicatePatcount: true,
        CPTCount: true,
        UnitCount: true,
    });

    const userData = useSelector((state) => state.user.user);
    console.log('userData:', userData);




    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;


    const sAuthToken = useSelector((state) => state.user.user.sAuthToken);



    const formatDate = (date) => {
        return date.toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
        });
    };



    useEffect(() => {
        document.title = "Patient Tracker";

        const today = new Date();

        // Get the first day of the current month
        const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        // Get the first day of the previous month
        const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

        // Get the last day of the previous month
        const lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);


        setStartDate(formatDate(firstDayOfLastMonth));
        setEndDate(formatDate(lastDayOfLastMonth));

    }, []);









    const handleTable1SearchChange = (event) => {
        setSearchQueryTable1(event.target.value);
    };

    const handleTable2SearchChange = (event) => {
        setSearchQueryTable2(event.target.value);
    };

    const handleTable3SearchChange = (event) => {
        setSearchQueryTable3(event.target.value);
    };


    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
    };



    const filteredTable1 = encounterData.filter(item =>
        (item.ProviderName?.toLowerCase().includes(searchQuery.toLowerCase()) || searchQuery === "") &&
        (item.ProviderName?.toLowerCase().includes(searchQueryTable1.toLowerCase()) || searchQueryTable1 === "")
    );

    const filteredTable2 = CptTrackerData.filter(item =>
        (item.ProviderName?.toLowerCase().includes(searchQuery.toLowerCase()) || searchQuery === "") &&
        (item.ProviderName?.toLowerCase().includes(searchQueryTable2.toLowerCase()) || searchQueryTable2 === "")
    );

    const filteredTable3 = unitTrackerTable1.filter(item =>
        (item.ProviderName?.toLowerCase().includes(searchQuery.toLowerCase()) || searchQuery === "") &&
        (item.ProviderName?.toLowerCase().includes(searchQueryTable3.toLowerCase()) || searchQueryTable3 === "")
    );





    const filteredAuditData = userAuditData?.filter((item) =>
        item.AuditDescription?.toLowerCase().includes(searchByAuditDescription.toLowerCase())
    );



    const filteredEncData = showEncounterPatient.filter((item) =>
        item.ProviderName?.toLowerCase().includes(searchByEncProvider.toLowerCase()) &&
        (`${item.FirstName} ${item.LastName}`.toLowerCase().includes(searchByEncPatientName.toLowerCase()))
    );


    const filteredEncPatData = showEncounterPatient.filter((item) =>

        `${item.FirstName} ${item.LastName}`.toLowerCase().includes(searchByEncPatientName.toLowerCase())
    );




    const providers = filteredTable1.map((item) => item.ProviderName || "-");
    const totalEncounters = filteredTable1.map((item) => Number(item.totalEncounters) || 0);
    const signedEncounters = filteredTable1.map((item) => Number(item.SignedEnc) || 0);
    const unsignedEncounters = filteredTable1.map((item) => Number(item.UnsignedEnc) || 0);
    const nonduplicatePatcount = filteredTable1.map((item) => Number(item.nonduplicatePatcount) || 0);
    const CPTCount = filteredTable1.map((item) => Number(item.CPTCount) || 0);
    const UnitCount = filteredTable1.map((item) => Number(item.UnitCount) || 0);






    const handleSort = (table, key) => {
        if (table === "table2") {
            setSortConfigTable2((prev) => ({
                key,
                ascending: prev.key === key ? !prev.ascending : true,
            }));
        } else if (table === "table3") {
            setSortConfigTable3((prev) => ({
                key,
                ascending: prev.key === key ? !prev.ascending : true,
            }));
        }
    };




    const sortedTable2 = [...filteredTable2].sort((a, b) => {
        if (!sortConfigTable2.key) return 0;
        const valA = Number(a[sortConfigTable2.key]) || 0;
        const valB = Number(b[sortConfigTable2.key]) || 0;
        return sortConfigTable2.ascending ? valA - valB : valB - valA;
    });

    const sortedTable3 = [...filteredTable3].sort((a, b) => {
        if (!sortConfigTable3.key) return 0;
        const valA = Number(a[sortConfigTable3.key]) || 0;
        const valB = Number(b[sortConfigTable3.key]) || 0;
        return sortConfigTable3.ascending ? valA - valB : valB - valA;
    });



    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);

            console.log("Selected start date:", formattedDate);
            setEndDate(format(date, 'MM/dd/yyyy'));
            setIsStartOpen(false)
        } else {
            setStartDate(null);
        }
    };


    const handleEndDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);
            console.log("Selected End date:", formattedDate);
            setIsEndOpen(false)

        } else {
            setEndDate(null);
        }
    };






    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };








    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);
            setEndDate(today);
            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };



    const CalendarContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
                    Today
                </button>

            </div>
        </div>
    );


    const CalendarStartContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
                    Today
                </button>

            </div>
        </div>
    );









    const chunkedProviders = [];
    for (let i = 0; i < providerData.length; i += 3) {
        chunkedProviders.push(providerData.slice(i, i + 3));
    }



    const getProvider = () => {


        var jsonOBJ = {
            PracticeID: userPracticeID,
            SearchByRole: 2
        }

        var sInputJSON = JSON.stringify(jsonOBJ);


        const url =
            APIConstants.COMMON_BASE_URL +
            `CommonData/GetPracticeProviders?sJSONInput=${sInputJSON}`;
        console.log("URL", url);

        const response = fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${sAuthToken}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {

                // const parsedData = data.objProviderGroups[0].objProviderList;

                console.log("Providers>>>>>>", data);
                setProviderData(Array.isArray(data) ? data : []);

            })

            .catch((error) => {
                console.error("Error fetching data: ", error);
            });
    };




    // Location list for the dropdown — the same practice locations the login
    // screen shows. Pulled once from the shared CommonData/GetLocationDetails
    // endpoint (returns [{ LocationId, LocationNickname }, ...]).
    const getLocationDetails = () => {
        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetLocationDetails}?sInputJSON={"PracticeID":${userPracticeID}}`;
        fetch(url, {
            method: 'GET',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': `Bearer ${sAuthToken}` }
        })
            .then((response) => (response.status !== 200 ? null : response.json()))
            .then((res) => {
                if (!res) return;
                const parsed = typeof res === 'string' ? JSON.parse(res) : res;
                setLocationData(Array.isArray(parsed) ? parsed : []);
            })
            .catch((err) => console.error('Error fetching locations:', err));
    };

    useEffect(() => {
        getLocationDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Refetch tracker data whenever the location changes. Skip the initial mount
    // (the load effects below already perform the first fetch).
    const isFirstLocationRender = useRef(true);
    useEffect(() => {
        if (isFirstLocationRender.current) { isFirstLocationRender.current = false; return; }
        handleAllTrackerDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLocationID]);


    const providerIds = providerData?.length > 0 ? providerData.map(provider => provider.ProviderID) : [];

    useEffect(() => {
        if (
            !hasFetched &&
            startDate &&
            endDate &&
            selectedProviders.length > 0 &&
            providerData?.length > 0 &&
            chunkedProviders?.length > 0
        ) {
            handleGetProviderData();
            handleGetRoleBasedCPTTrackerData();
            handleGetRoleBasedCPTUnitsData();
            getProvider();
            setHasFetched(true);
        }
    }, [startDate, endDate, hasFetched, selectedProviders, providerData, chunkedProviders]);






    useEffect(() => {
        getProvider();
        setLoading(true);
        setTimeout(() => {
            handleAllTrackerDetails();
            setLoading(false);
        }, 500);

        console.log("Providers>>>>>>", providerData, providerIds);
    }, []);




    const handleGetProviderData = async () => {
        console.log("Providers>>>>>>", providerData, providerIds);

        var jsonOBJ = {
            sFromDate: startDate,
            sToDate: endDate,
            lsProviders: selectedProviders,
            sLocationID: selectedLocationID


        }

        var sInputJSON = JSON.stringify(jsonOBJ);

        console.log("INPUT OF " + PatientTrackerConstants.GetProviderEncounterTrackerData, sInputJSON);


        const url = `${APIConstants.BASE_URL_BILLING}${PatientTrackerConstants.GetProviderEncounterTrackerData}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)

                setEncounterData(parsedData)

                console.log("Response of" + PatientTrackerConstants.GetProviderEncounterTrackerData, parsedData);




            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }






    const handleGetRoleBasedCPTTrackerData = async () => {


        var jsonOBJ = {
            sFromDate: startDate,
            sToDate: endDate,
            lsProviders: selectedProviders,
            sLocationID: selectedLocationID,
            sRoleID: userData.roleID,
            sPracticeID: userPracticeID


        }

        var sInputJSON = JSON.stringify(jsonOBJ);


        const url = `${APIConstants.BASE_URL_BILLING}${PatientTrackerConstants.GetRoleBasedCPTTrackerData}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)
                setCptTrackerData(parsedData.Table1)
                setCptTrackerTable2(parsedData.Table2)
                console.log("Response of" + PatientTrackerConstants.GetRoleBasedCPTTrackerData, parsedData, CptTrackerData);




            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }







    const handleGetRoleBasedCPTUnitsData = async () => {


        var jsonOBJ = {
            sFromDate: startDate,
            sToDate: endDate,
            lsProviders: selectedProviders,
            sLocationID: selectedLocationID,
            sRoleID: userData.roleID,
            sPracticeID: userPracticeID


        }

        var sInputJSON = JSON.stringify(jsonOBJ);


        const url = `${APIConstants.BASE_URL_BILLING}${PatientTrackerConstants.GetRoleBasedCPTUnitsData}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)
                setUnitTrackerTable1(parsedData.Table1)
                setUnitTrackerTable2(parsedData.Table2)
                console.log("Response of" + PatientTrackerConstants.GetRoleBasedCPTUnitsData, parsedData, unitTrackerTable1);




            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    const handleAllTrackerDetails = () => {
        // Skip the premature initial call that fires (via the mount setTimeout's
        // stale closure) before the dates are ready — it would hit the API with
        // empty sFromDate/sToDate and return 400. The real load comes from the
        // gated effect once dates + providers are available.
        if (!startDate || !endDate) {
            return;
        }
        setLoading(true);
        setTimeout(() => {
            handleGetProviderData();
            handleGetRoleBasedCPTTrackerData();
            handleGetRoleBasedCPTUnitsData();
            setLoading(false);
        }, 500);



    }







    const handleGetPatientTrackerDetailedData = async (item, countType) => {


        var jsonOBJ = {

            sProviderID: item.ProviderID,
            sRoleID: item.UserRole,
            sFromDate: startDate,
            sToDate: endDate,
            sSignedIndicator: countType,
            sIsSupervisor: item.isSuperVisor,
            sPracticeID: userPracticeID,


        }

        var sInputJSON = JSON.stringify(jsonOBJ);


        const url = `${APIConstants.BASE_URL_BILLING}${PatientTrackerConstants.GetPatientTrackerDetailedData}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)
                setShowEncounterPatient(parsedData)

                if (countType === 2) {
                    setShowDataModal(true)
                }

                else {
                    setShowEncModal(true)
                }
                console.log("Response of" + PatientTrackerConstants.GetPatientTrackerDetailedData, parsedData);




            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }






    const handleGetUserAudits = (item) => {

        console.log("Data", item);


        const InputJSON = {

            PracticeID: userPracticeID,
            DataID: 0,
            Module: 'Provider_Encounter',
            SubModule: '',
            sFromDate: startDate,
            sToDate: endDate,
            PatientID: item.PatientID ?? "",
            UserID: item.UserID ?? item.ProviderUserID ?? ""
        };


        const sInputJSON = JSON.stringify(InputJSON);

        console.log("Input of " + PatientTrackerConstants.GetUserAudits, sInputJSON);

        const url = `${APIConstants.BASE_AUDIT_URL}${PatientTrackerConstants.GetUserAudits}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                console.log('API response:' + PatientTrackerConstants.GetUserAudits, parsedData);
                setShowAuditModal(true)
                setUserAuditData(parsedData)

            })
            .catch(error => {
                console.error(' PDF failed', error);
            });
    };





    const handleGetEncounterAudits = (item) => {

        console.log("Data", item);


        const InputJSON = {

            PracticeID: userPracticeID,
            DataID: 0,
            Module: 'Provider_Encounter',
            SubModule: '',
            sFromDate: item.DOSString,
            sToDate: item.DOSString,
            PatientID: item.PatientID ?? "",
            UserID: ""
        };


        const sInputJSON = JSON.stringify(InputJSON);

        console.log("Input of " + PatientTrackerConstants.GetUserAudits, sInputJSON);

        const url = `${APIConstants.BASE_AUDIT_URL}${PatientTrackerConstants.GetUserAudits}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                console.log('API response:' + PatientTrackerConstants.GetUserAudits, parsedData);
                setShowAuditModal(true)
                setUserAuditData(parsedData)

            })
            .catch(error => {
                console.error(' PDF failed', error);
            });
    };


    const handleRowClick = (index) => {
        setActiveRow(index);
    };



    const handleUnitRowClick = (index) => {
        setUnitActiveRow(index);
    };



    const formatDOSDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    };



    const handleCloseModals = () => {
        // Close all modals

        setShowDataModal(false)
        setShowEncModal(false);


    };


    const handleAuditCloseModals = () => {

        setShowAuditModal(false);

    }


    // Default-select every provider ONCE, the first time the provider list loads.
    // (The old effect re-selected everyone whenever the selection was empty, and
    // because `chunkedProviders` is rebuilt every render it ran after every render
    // — which made the "Clear all" button instantly re-check all providers.)
    const didInitSelection = useRef(false);
    useEffect(() => {
        if (!didInitSelection.current && providerData.length > 0) {
            didInitSelection.current = true;
            setSelectedProviders(providerData.map(provider => provider.ProviderID));
        }
    }, [providerData]);



    const handleCheckboxChange = (providerID) => {
        setSelectedProviders(prevSelected =>
            prevSelected.includes(providerID)
                ? prevSelected.filter(id => id !== providerID)
                : [...prevSelected, providerID]
        );
    };


    const columns = [
        { header: "#", accessor: "index" },
        { header: "Name", accessor: "ProviderName" },
        { header: "Total Patients", accessor: "nonduplicatePatcount" },
        { header: "Signed Encounters", accessor: "SignedEnc" },
        { header: "Unsigned Encounters", accessor: "UnsignedEnc" },
        { header: "Total Encounters", accessor: "totalEncounters" },
        { header: "Total CPTs", accessor: "CPTCount" },
        { header: "Total Units", accessor: "UnitCount" }
    ];






    const getSignedOffMsg = (EncounterStatus, AssistantSignoff) => {
        if (EncounterStatus === "True" && AssistantSignoff === "1") {
            return "Both";
        } else if (EncounterStatus === "True" && AssistantSignoff === "0") {
            return "Supervisor";
        } else if (EncounterStatus === "False" && AssistantSignoff === "1") {
            return "Non Supervisor";
        } else {
            return "None";
        }
    };





    const uniqueServices = [...new Set(CptTrackerTable2.map(item => item.ServiceName))];


    const groupedCPTs = uniqueServices.map(service => ({
        service,
        cpts: CptTrackerTable2.filter(item => item.ServiceName === service).map(item => item.CPT)
    }));




    const cptCodes = groupedCPTs.flatMap((group) => group.cpts);




    //Filtered Units Tracker Data

    const unitServices = [...new Set(unitTrackerTable2.map(item => item.ServiceName))];


    const groupedunits = unitServices.map(service => ({
        service,
        cpts: unitTrackerTable2.filter(item => item.ServiceName === service).map(item => item.CPT)
    }));



    const unitCodes = groupedunits.flatMap((group) => group.cpts);



    const handlePatLinkClick = (item) => {
        const url = `/#/patient-dashboard/${item.PatientID}/primary-insurance`;

        console.log("PatientID>>>", item.PatientID);
        localStorage.setItem("PatientID", item.PatientID);

        window.open(url, '_blank');
    };





 const printRef = useRef();

  

 const handleGraphPrint = (chartTitle) => {
    const printWindow = window.open("", "_blank");
    const chartContent = printRef.current.innerHTML;

    printWindow.document.writeln(`
      <html>
        <head>
        <title>Encounter Data Overview </title>
          <style>
            @media print {
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                margin: 0;
                padding: 10px;
                font-family: Arial, sans-serif;
              }
              #chart-title {
                text-align: center;
                font-size: 2rem;
                font-weight: bolder;
                color: black;
                margin-bottom: 20px;
                text-transform:uppercase;
              }
              #bar {
                text-align: center;
              }
               .apexcharts-menu, .apexcharts-toolbar, .apexcharts-xcrosshairs, .apexcharts-ycrosshairs {
                display: none !important;
              }
            }
          </style>
        </head>
        <body>
          <div id="chart-title">${chartTitle}Chart</div>
          <div id='bar'>
            ${chartContent}
          </div>
          <script>
            window.onload = function () {
              window.print();
              window.close();
            }
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
};



    const handlePrint = (tableId) => {
        const printElement = document.getElementById(tableId);

        if (!printElement) {
            console.error(`Element with ID '${tableId}' not found.`);
            return;
        }

        const printContent = printElement.innerHTML;

        const printWindow = window.open("", "_blank");

        if (printWindow) {
            printWindow.document.writeln(`
                   <html>
                   <head>
                       <title>Patient Tracker</title>
                       <style>
                           @media print {
                               body {
                                   margin: 0;
                                   padding: 10px;
                                   font-family: Arial, sans-serif;
                                   zoom: 0.8; 
                                   color:#000305 !important;
                                   font-size: 28px; 
                               }

                               .print-title {
                                font-size: 2rem;
                                font-weight: bolder;
                               
                                margin-bottom: 20px;
                            }

                               table {
                                   width: auto !important; 
                                   border-collapse: collapse; 
                                   table-layout: fixed;
                                   word-wrap: break-word;
                               }
                               th, td {
                                   border: 2px solid black !important; 
                                   padding: 8px;
                                   text-align: center;
                                   word-wrap: break-word;
                                   background-color: white; 
                                   color: black !important; 
                                    font-size: 18px; 
                                    font-weight: bolder;
                               }
                               th {
                                   background-color: #0173b7;
                                   color: white;
                               }
                               td {
                                   background-color: #f8f9fa;
                               }
                               td:last-child, th:last-child {
                                   white-space: normal !important;
                                   overflow: visible !important;
                               }
                               .patient-table {
                                   page-break-inside: avoid; 
                                   max-height: 100vh;
                               }
                               @page {
                                   size: A4 landscape;
                                   margin: 10mm;
                               }
                               .pdf-icon {
                                   width: 20px;
                                   height: 20px;
                               }
                           }
                       </style>
                   </head>
                   <body>

                    <div class="print-title">${tableId}-${formattedStartDate} - ${formattedEndDate}</div> 
                       ${printContent}
                       <script>
                            window.onload = function() {
                        window.print();
                    };
                    window.onafterprint = function() {
                        window.close();
                    };
                 
                    window.addEventListener('focus', function () {
                        window.close();
                    });
                       </script>
                   </body>
                   </html>
               `);
            printWindow.document.close();
        } else {
            console.error("Failed to open print window.");
        }
    };










    const encounterTableRef = useRef(null);
    const sortedTable2Ref = useRef(null);
    const sortedTable3Ref = useRef(null);

    const patientTableRef = useRef(null);



    const exportEncToExcel = (tableId, pageName) => {
        let table;

        if (tableId === "encounterTable") {
            table = encounterTableRef.current;
        } else if (tableId === "cptTrackerTable") {
            table = sortedTable2Ref.current;
        } else if (tableId === "unitTrackerTable") {
            table = sortedTable3Ref.current;
        }
        else if (tableId === "patientTracker") {
            table = patientTableRef.current;
        }

        if (!table) {
            console.error(`Table with ID '${tableId}' not found.`);
            return;
        }

        let sPrintableData = table.innerHTML;
        if (!sPrintableData) {
            console.error("No table data found.");
            return;
        }

        console.log(`Exporting ${pageName} Table HTML:`, sPrintableData);


        const requestData = {
            PrintableData: sPrintableData,
            PageName: pageName,
        };


        const InputJSONLevelOne = JSON.stringify(requestData);
        const InputJSON = JSON.stringify(InputJSONLevelOne);

        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        console.error("Export to Excel failed:", errorData);
                        throw new Error(`Server responded with status ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log('API response:', data);
                if (data && data[2]) {
                    toast.success('Export ready — opening file'); window.open(data[2], '_blank');
                } else {
                    console.error("Invalid API response format.");
                }
            })
            .catch(error => {
                toast.error('Export to Excel failed'); console.error('Export to Excel failed', error);
            });
    };






    const exportToExcel = (tableId, pageName) => {
        let table, tableData;

        if (tableId === "encounterTable") {
            table = encounterTableRef.current;
            tableData = encounterData;
        } else if (tableId === "cptTrackerTable") {
            table = sortedTable2Ref.current;
            tableData = sortedTable2;
        } else if (tableId === "unitTrackerTable") {
            table = sortedTable3Ref.current;
            tableData = sortedTable3;
        }

        if (!table || !tableData) {
            console.error(`Table with ID '${tableId}' not found or has no data.`);
            return;
        }

        let sPrintableData = "<table border='1'>";

        // Table Head
        sPrintableData += "<thead><tr>";
        sPrintableData += "<th>#</th>";
        sPrintableData += "<th>Name</th>";

        groupedCPTs.forEach(group => {
            group.cpts.forEach(cpt => {
                sPrintableData += `<th>${cpt}</th>`;
            });
        });


        sPrintableData += "<th>Total</th></tr></thead>";


        sPrintableData += "<tbody>";
        tableData.forEach((item, index) => {
            let rowTotal = cptCodes.reduce((sum, cpt) => sum + (Number(item[cpt]) || 0), 0);

            sPrintableData += `<tr>`;
            sPrintableData += `<td>${index + 1}</td>`;
            sPrintableData += `<td>${item.ProviderName}</td>`;

            cptCodes.forEach(cpt => {
                sPrintableData += `<td>${item[cpt] ? item[cpt] : "0"}</td>`;
            });



            sPrintableData += `<td>${rowTotal}</td>`;
            sPrintableData += `</tr>`;
        });
        sPrintableData += "</tbody>";


        sPrintableData += "<tfoot><tr>";


        sPrintableData += `<td colspan="2"><strong>Total</strong></td>`;
        sPrintableData += `<td colspan="2"></td>`;


        cptCodes.forEach(cpt => {
            let totalCPTValue = tableData.reduce((sum, row) => sum + (Number(row[cpt]) || 0), 0);
            sPrintableData += `<td>${totalCPTValue}</td>`;
        });





        let grandTotal = tableData.reduce(
            (totalSum, row) => totalSum + cptCodes.reduce((rowSum, cpt) => rowSum + (Number(row[cpt]) || 0), 0),
            0
        );

        sPrintableData += `<td>${grandTotal}</td>`;
        sPrintableData += "</tr></tfoot>";

        sPrintableData += "</table>";

        console.log(`Exporting ${pageName} Table HTML:`, sPrintableData);

        const requestData = {
            PrintableData: sPrintableData,
            PageName: pageName,
        };

        const InputJSON = JSON.stringify(JSON.stringify(requestData));

        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: InputJSON,
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        console.error("Export to Excel failed:", errorData);
                        throw new Error(`Server responded with status ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log("API response:", data);
                if (data && data[2]) {
                    toast.success('Export ready — opening file'); window.open(data[2], "_blank");
                } else {
                    console.error("Invalid API response format.");
                }
            })
            .catch(error => {
                toast.error('Export to Excel failed'); console.error("Export to Excel failed", error);
            });
    };




    const exportToPDF = (tableId, pageName) => {
        let table;

        if (tableId === "encounterTable") {
            table = encounterTableRef.current;
        } else if (tableId === "cptTrackerTable") {
            table = sortedTable2Ref.current;
        } else if (tableId === "unitTrackerTable") {
            table = sortedTable3Ref.current;
        }
        else if (tableId === "patientTracker") {
            table = patientTableRef.current;
        }

        if (!table) {
            console.error(`Table with ID '${tableId}' not found.`);
            return;
        }

        let sPrintableData = table.innerHTML;
        if (!sPrintableData) {
            console.error("No table data found.");
            return;
        }

        console.log(`Exporting ${pageName} Table HTML:`, sPrintableData);


        const tableWithStyles = `
               <style>
                 body { font-family: Arial, sans-serif; margin: 20px; }
                  h1 { text-align: center; font-size: 20px; margin-bottom: 20px; text-transform:camelcase; justify-content: space-between; }
                   table { border-collapse: collapse; width: 100%; }
                   th, td { border: 1px solid black; padding: 5px; text-align: left; }
                   th { background-color: #f2f2f2; }
               </style>
                <h1>${pageName}</h1>
                <h1>${formattedStartDate} - ${formattedEndDate}</h1>
               ${sPrintableData}
           `;

        const requestData = {
            PrintableData: tableWithStyles,
            PageName: pageName,
        };

        const InputJSONLevelOne = JSON.stringify(requestData);
        const InputJSON = JSON.stringify(InputJSONLevelOne);

        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        console.error("Export to PDF failed:", errorData);
                        throw new Error(`Server responded with status ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log('API response:', data);
                if (data && data[2]) {
                    toast.success('Export ready — opening file'); window.open(data[2], '_blank');
                } else {
                    console.error("Invalid API response format.");
                }
            })
            .catch(error => {
                toast.error('Export to PDF failed'); console.error('Export to PDF failed', error);
            });
    };



    const filterData = (key) => {
        if (!visibleCounts[key]) return [];

        return filteredTable1.map((item) => {
            if (key === "totalEncounters") {
                return (Number(item.SignedEnc) || 0) + (Number(item.UnsignedEnc) || 0);
            }
            return Number(item[key]) || 0;
        });
    };




    const labels = {
        totalEncounters: "Total Encounters",
        SignedEnc: "Signed",
        UnsignedEnc: "Unsigned",
        nonduplicatePatcount: "Total Patients",
        CPTCount: "Total CPTs",
        UnitCount: "Total Units"
    };

    const handleCheckboxCountsChange = (countType) => {
        setVisibleCounts(prevState => ({
            ...prevState,
            [countType]: !prevState[countType]
        }));
    };




    const count = Math.max(...filteredTable1.map(o => (Number(o.CPTCount))), 0)
    const UnitCounts = Math.max(...filteredTable1.map(o => (Number(o.UnitCount))), 0);
    const Totalpat = Math.max(...filteredTable1.map(o => (Number(o.nonduplicatePatcount))), 0);
    const TotalEnc = Math.max(...filteredTable1.map(o => (Number(o.UnsignedEnc) + Number(o.SignedEnc))), 0);
    const maxvalue = Math.max(count, UnitCounts, Totalpat, TotalEnc)


    const RoundValue = () => {

        if (maxvalue % 10 === 0) {
            return maxvalue
        }
        else {

            const fractionVal = maxvalue % 10;
            const nonFractionVal = maxvalue - fractionVal

            return nonFractionVal + 10;
        }

    }



    const chartData = {
        providers,
        totalEncounters: filterData("totalEncounters"),
        signedEncounters: filterData("SignedEnc"),
        unsignedEncounters: filterData("UnsignedEnc"),
        nonduplicatePatcount: filterData("nonduplicatePatcount"),
        CPTCount: filterData("CPTCount"),
        UnitCount: filterData("UnitCount"),
        maxvalue: RoundValue()
    };

    const formattedStartDate = new Date(startDate).toLocaleDateString('en-US');
    const formattedEndDate = new Date(endDate).toLocaleDateString('en-US');




    return (
        <TrackerDashboardV2 ctx={{
            roleLabel: "Nurse",
            startDate, endDate, loading, setStartDate, setEndDate,
            handleStartDateChange, handleEndDateChange, onApply: handleAllTrackerDetails,
            searchQuery, handleSearchChange, setSearchQuery,
            providerData, selectedProviders, setSelectedProviders, handleCheckboxChange,
            locationData, selectedLocationID, setSelectedLocationID,
            filteredTable1,
            handleGetPatientTrackerDetailedData, handleGetUserAudits, encounterTableRef,
            groupedCPTs, cptCodes, sortedTable2, CptTrackerData, searchQueryTable2, handleTable2SearchChange, sortConfigTable2, sortedTable2Ref,
            groupedunits, unitCodes, sortedTable3, unitTrackerTable1, searchQueryTable3, handleTable3SearchChange, sortConfigTable3, sortedTable3Ref,
            handleSort,
            chartData, formattedStartDate, formattedEndDate,
            exportEncToExcel, exportToExcel, exportToPDF,
            showDataModal, showEncModal, showAuditModal,
            filteredEncData, filteredEncPatData, filteredAuditData,
            handleCloseModals, handleAuditCloseModals,
            handlePatLinkClick, handleGetEncounterAudits, getSignedOffMsg, formatDOSDate, patientTableRef,
        }} />
    )
}

export default NurseTracker